
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import Linkify from 'linkify-react'

import UserAvatar from '../../UserAvatar/UserAvatar'

import './RestrictionComment.scss'

interface Props {
  item: any
}

const RestrictionComment = ({ item }: Props) => {

  const { users } = useSelector((state: any) => state.ProgrammationReducer)

  const [ user, setUser ] = useState(item.user)
  const [ time, setTime ] = useState(moment(item.createdAt).fromNow())

  const linkOptions = {
    defaultProtocol: 'https',
    target: '_blank',
    rel: 'noopener noreferrer'
  };

  useEffect(() => {

    const updateTime = () => {

      setTimeout(() => {

        updateTime()
        setTime(moment(item.createdAt).fromNow())
      }, 1000)
    }

    updateTime()

    if (typeof item.user === 'string') {

      const user = users.find((u: any) => u._id === item.user)

      if (user) {

        setUser(user)
      }
    }
  }, [ item ])

  if (!user) return null

  return (
    <div className="restriction-comment">
      <div className="user-avatar">
        <UserAvatar user={user} />
      </div>
      <div className="bubble">
        <div className="header">
          <div className="username">
            {user.name} {user.surname}
          </div>
          <div className="time-ago">
            {time}
          </div>
        </div>
        <div>
          <Linkify options={linkOptions}>{item.comment}</Linkify>
        </div>
      </div>
    </div>
  )
}

export default RestrictionComment
